module.exports = __webpack_public_path__ + "static/media/cardscollection.52f4e859.png";